import { ButtonThird } from '@components/shared/buttons/button-third';
import Image from 'next/image';
import style from './index.module.scss'

interface ImageTextBlockProps {
    title: string;
    text: string[];
    imageSrc: string;
    imageAlt?: string;
}

export const ImageTextBlock = ({ title, text, imageSrc, imageAlt }: ImageTextBlockProps) => {
    let lastArrayIndex = text.length - 1;
    return (
        <div className={`${style.block}`}>
            <div className={`${style.image}`}>
                <Image src={imageSrc} alt={imageAlt || title} layout={'fill'} />
            </div>
            <div className={`${style.block__item}`}>
                <h2 className={`${style.title}`}>
                    {title}
                </h2>
                <div className={`${style.text__block}`}>
                    {
                        text.map((item: string, index: number) => {
                            return (
                                <div className={`${style.text__item} ${lastArrayIndex === index ? style.text__item_last : null}`} key={index}>
                                    {item}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}